import { DefaultDetailContext } from 'src/app/controls/forms/default-detail-context';
import { IEmailTemplate } from 'src/app/models/interfaces/email-template.interface';
import { EmailsTemplatesFormContext } from './emails-tempaltes-form-context';

export class EmailsTemplatesDetailContext extends DefaultDetailContext<IEmailTemplate, number> {
    private _global: boolean;

    public get global(): boolean {
        return this._global;
    }

    public set global(value: boolean) {
        this._global = value;
        (this.formContext as EmailsTemplatesFormContext).global = value;
    }
}
